module.exports = __webpack_public_path__ + "static/media/image-1.c838e693.jpg";